import { render } from "./CosmoSetTime.vue?vue&type=template&id=47f01f04&scoped=true"
import script from "./CosmoSetTime.vue?vue&type=script&lang=js"
export * from "./CosmoSetTime.vue?vue&type=script&lang=js"

import "./CosmoSetTime.vue?vue&type=style&index=0&id=47f01f04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f01f04"]])

export default __exports__